export default __webpack_public_path__ + "static/media/project3.bd02f7cf.png";